module.exports = "https://p.cds.unp.clasificados.pe/logo-pagoefectivo.8c154be0c347205398e2056b86d81705.svg";